import { FLAG_TONE, PHASE_GLYPH } from '../lib/constants.js';

export function PhaseStrip({ guide }) {
  if (!guide) return null;
  const { phase, currentHourStatus: cur } = guide;
  const tone = FLAG_TONE[cur.color] || FLAG_TONE.gray;
  return (
    <div className="card">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
        <span style={{ fontSize: 22 }}>{PHASE_GLYPH[phase.icon] || '•'}</span>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#212121' }}>{phase.name}</div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: '#757575', textTransform: 'uppercase' }}>Expect this hour</div>
          <div style={{ fontSize: 16, fontWeight: 600, color: '#212121', marginTop: 2 }}>
            {cur.forecastRange === '—' ? '—' : `${cur.forecastRange} tx`}
          </div>
          <div style={{ fontSize: 11, color: '#757575' }}>({cur.confidence})</div>
        </div>
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: '#757575', textTransform: 'uppercase' }}>Actual so far</div>
          <div style={{ fontSize: 16, fontWeight: 600, color: '#212121', marginTop: 2 }}>{cur.actualSoFar} tx</div>
        </div>
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: '#757575', textTransform: 'uppercase' }}>Status</div>
          <div style={{ display: 'inline-block', marginTop: 2, padding: '4px 10px', borderRadius: 12, background: tone.bg, color: tone.text, fontWeight: 600, fontSize: 12 }}>
            {cur.statusLabel}
          </div>
        </div>
      </div>
    </div>
  );
}
